var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.nodes),function(node,n){return [(_vm.is_emote(node))?_c('img',{key:n,staticClass:"align-middle inline-block",attrs:{"src":_vm.image_src(node),"alt":node}}):(_vm.is_placeholder(node))?[_c('span',{key:node,staticClass:"tags"},[_vm._v(_vm._s(node))])]:[_vm._v(" "+_vm._s(node))]]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }